<template>
  <div>
    <gmap-autocomplete
      class="form-control"
      :placeholder="placeholder"
      @place_changed="setPlace"
      :selectFirstOnEnter="true"
      :value="search"
      :options="{types : ['(cities)']}"
      ref="autocomplete"
      :disabled="!enabled"
      v-on:keydown.enter.prevent
    >
    </gmap-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'SearchCity',
  props: {
    enabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * This prop is used to adjust the logic behind the @function setPlace logic
     * If set to false, the input will retail the name of the place shown
     *  instead of being reset to empty
     */
    resetOnSetPlace: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * This prop is to make the autocomplete input emit the name of the place
     *  selected rather than an object of its placeId and name
     */
    emitCityName: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      cities: [],
    };
  },
  computed: {
    placeholder() {
      return this.enabled ? 'Your city' : '3 cities max';
    },
  },
  methods: {
    setPlace(event) {
      const result = event.address_components;
      const country = result.find(element => element.types.indexOf('country') > -1);
      const state = result.find(element => element.types.indexOf('administrative_area_level_1') > -1);
      const city = result.find(element => element.types.indexOf('locality') > -1);
      const formatted = [];

      if (city) {
        formatted.push(city.long_name);
      }

      if (country.short_name === 'US' || country.short_name === 'USA' || country.short_name === 'CA') {
        formatted.push(state.short_name);
      }

      if (country.short_name === 'US' || country.short_name === 'USA') {
        formatted.push('USA');
      } else {
        formatted.push(country.long_name);
      }

      const place = formatted.join(', ');

      if (this.emitCityName) {
        this.$emit('select', place);
      } else {
        this.$emit('select', {
          placeId: event.place_id,
          place,
        });
      }

      if (this.resetOnSetPlace) {
        this.search = '';
        this.$refs.autocomplete.$el.value = this.search;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  input, input:active, input:focus, input:disabled {
    height: 52px;
    width: 100%;
    margin: auto;

    border: 1px solid #b4b4b4;
    color: $white;
    background: $black url('../assets/svg/search.svg') no-repeat 15px 14px;
    padding-left: 48px;

    &::placeholder {
      color: #505050;
    }
  }
</style>

<style lang="scss">
  @import '../assets/css/variables';
  @import '../assets/css/google.places';
</style>
